import { FETCH_ESCROW_CONTENT } from '../types'
export default (state = null, action) => {
  switch (action.type) {
    case FETCH_ESCROW_CONTENT:
      return action.payload
    default:
      return state;
  }
}